<template>
  <div class="fino-page">
    <div class="auth-card">
      <div class="auth-card-title">{{ lang.title }}</div>
      <p class="auth-card-text">{{ lang.text }}</p>
      <form class="auth-form" @submit="submit()">
        <!--        <VerifyCodeInput @change="e=>onChange(e)" @complete="submit()" :num="5" />-->
        <div class="code-input-container">
          <CodeInput
            dir="ltr"
            class="input"
            :fields="5"
            :fieldHeight="28"
            :fieldWidth="33"
            :loading="false"
            @change="onChange"
            @complete="submit"
            ref="code-input"
          />
        </div>
        <span style="color: white"> {{ countDown }}</span>
        <button
          :class="{ disabled: otp.code.length < 5 }"
          v-if="countDown > 0"
          :disabled="otp.code.length < 5"
          type="submit"
          class="auth-confirm-btn"
          @click="submit"
        >
          {{ lang.confirmBtn }}
        </button>
        <button class="auth-confirm-btn" v-if="countDown == 0" @click="send()">
          {{ lang.resendBtn }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import CodeInput from "vue-verification-code-input";

export default {
  components: {
    CodeInput,
  },
  name: "Finotech",
  data() {
    return {
      lang: this.$languageDict().otpConfirm,

      verifyTypes: {
        Email: "ایمیل",
        SMS: "شماره موبایل",
        GoogleAuth: "شناسایی گوگل",
      },
      countDown: 120,
      error: "",
      code: "",
      num: 6,
      otp: {
        code: "",
        email: this.state.userInfo.email || this.$cookies.get("username"),
        phoneNumber: this.state.userInfo.mobilenumber,
      },
    };
  },
  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        this.timeOut = setTimeout(() => {
          this.countDown--;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$error("زمان شما به اتمام رسید", "");
      }
    },
    async send() {
      this.state.loading = true;
      await this.$axios.get(
        `/finnotech/send-sms-to-customer?email=${this.state.userInfo.email}`
      );

      this.$error(
        "کد جدید به " + this.verifyTypes[this.verifyType] + " شما ارسال شد.",
        "",
        "success"
      );
      this.$cookies.set("username", this.state.userInfo.email);
      if (this.countDown === 0) {
        this.countDown = 120;
        this.countDownTimer();
      }
    },

    onChange(e) {
      this.otp.code = e;
    },
    async submit() {
      this.state.loading = true;

      const res = await this.$axios.get("/finotech/otp", {
        params: {
          otp: this.otp.code,
          email: this.state.userInfo.email,
        },
      });

      if (res) {
        (await this.state.lang) == "fa"
          ? this.$error(
              "",
              "فرایند احراز هویت انجام شد. منتظر تایید اطلاعات توسط پشتیبانی باشید.",
              "success"
            )
          : this.$error("Authorization Completed Please Wait For Approve");
        await this.$router.push("/Panel/Profile");
      }

      this.state.loading = false;
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
  mounted() {
    console.log("hi");
    if (!this.otp.email) {
      this.$router.push("/login");
    }
    if (this.verifyType !== "GoogleAuth") {
      this.countDownTimer();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.fino-page {
  $height: 35vh;
  min-height: $height;
  display: flex;
  justify-content: center;
  margin-top: calc($height / 2);
}
</style>
<style scoped>
::v-deep input[type="tel"]::placeholder {
}

::v-deep .input {
  width: 100% !important;
}

.code-input-container {
  overflow: hidden;
  max-height: 44px;
  border: initial !important;
}

::v-deep .react-code-input {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #060d35;
  padding: 0px 14px;
  column-gap: 8px;
  height: 44px;
  width: 100%;
  border-radius: 4px;
  direction: ltr;
}

::v-deep input {
  border: none !important;
  border-bottom: 2px solid #c4c4c4 !important;
  padding: 0px !important;
  font-family: "VistaDev", sans-serif !important;
  font-size: clamp(16px, 2vw, 24px);
  border-radius: initial !important;
  width: 100% !important;
  max-width: 40px;
  letter-spacing: -2px;
  text-align: center !important;
  color: white !important;
  background: transparent;
}

/* ::v-deep .react-code-input {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 14px;
    column-gap: 6px;
    height: 44px;
    width: 100% ;
    max-width: 317px;
    background: #060D35;
    border-radius: 4px;
}

::v-deep input {
    size: 1px;
    min-width: 10px !important;
    width: 100%;
    border: none !important;
    border-bottom: 2px solid #BDBDBD !important;
    font-family: 'VistaDev', sans-serif !important;
    font-size: 25px;
    color: white !important;
    background: transparent;
    border-radius: 0px !important;
    letter-spacing: -2px;
    text-align: center !important;
} */

/*

input[type="number"] {

text-align: center;

appearance: textfield;
      font-size: clamp(18px,1.6vw,19px);

-webkit-appearance: textfield;
    flex-grow: 1;
    max-width: clamp(30px,3.1vw,33px);
    border-radius: 4px;
    background: #EDF1ED;

}
.code-container{
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    padding: 9px ;
    justify-content: center;
    column-gap: clamp(5px,1.3vw,15px);
   background: #EDF1ED;
border-radius: 6px;
}
.underline{
    width: 100%;
    height: 2px;
    border-radius: 1px;
    background: #BDBDBD;
} */
</style>
